import {
  orderStatusConfig,
  StockTypeUpdateRowsData,
  StockTypeUpdateSkuDetail,
} from "../../../types/types";
import { ChannelkartNetworkGet } from "../../../services/networkService";
import { clearAllDataFromLocalDb, insertDataIntoLocalDB } from "../../../services/dbService";
import { Product } from "../../createSecondaryOrder/models";
import { EnvironmentRegistry } from "../../../services/registry/environmentRegistry";
import { normalizeQuantityDisplay } from "../manualStockAdjustment/ManualStockAdjustmentUtils";

export const setStockTypeUpdateDataInDb = async (startDate: string, endDate: string, distributorId?: string) => {
  try {
    const loginId = distributorId ?? JSON.parse(localStorage.authContext).user.loginId;
    const response = await ChannelkartNetworkGet(
      `${EnvironmentRegistry.getStockBaseUrl()}/consolidatedStock/getTypeTransfer?supplier=${loginId}&minimalResponse=true&startDate=${startDate}&endDate=${endDate}`
    );
    await clearAllDataFromLocalDb("StockTypeUpdateData");
    await insertDataIntoLocalDB("StockTypeUpdateData", response.data["content"]);
  } catch (error) {
    console.log(error);
    throw new Error()
  }
};

export const sumUpdatedQuantities = async (dataList: StockTypeUpdateSkuDetail[], skuCode: string) => {
  // Initialize sums
  let totalUpdatedPieceQty = 0;
  let totalUpdatedCaseQty = 0;
  let totalUpdatedOtherQty = 0;

  // Loop through each item in the list and sum the quantities
  dataList.forEach((item) => {
    totalUpdatedPieceQty += item.pieceQty || 0;
    totalUpdatedCaseQty += item.caseQty || 0;
    totalUpdatedOtherQty += item.otherQty || 0;
  });

  // Normalize the quantities before returning
  const normalizedQty = await normalizeQuantityDisplay(
    totalUpdatedCaseQty,
    totalUpdatedPieceQty,
    totalUpdatedOtherQty,
    skuCode
  );

  // Return the normalized results
  return {
    totalUpdatedPieceQty: normalizedQty.pieceQty,
    totalUpdatedCaseQty: normalizedQty.caseQty,
    totalUpdatedOtherQty: normalizedQty.otherQty,
  };
};

export const getMergedCatalogueAndBatchIdData = (
  stockData: StockTypeUpdateRowsData[],
  productsMap: Record<string, Product>
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  return stockData.map((item) => {
    const product = productsMap[item.skuCode];
    return {
      ...item,
      skuDescription: product?.skuDescription ?? "",
      uom:ConfigDictionary.orderUomCheck === "true" ? (product?.uom ?? "") : "all",
      otherUnitName: product.otherUnitName
    };
  });
};

export const StockTypeUpdateStatusMapping: orderStatusConfig[] = [
  {
    id: "available",
    dmsLabelColor: "#17B4A3",
    dmsLabel: "Available",
    dmsColor: "#F0FBFF",
  },
  {
    id: "unsellable",
    dmsLabelColor: "#C44C36",
    dmsLabel: "Unsellable",
    dmsColor: "#FFFAF7",
  },
  {
    id: "returned",
    dmsLabelColor: "#909090",
    dmsLabel: "Returned",
    dmsColor: "#F7F7F7",
  },
  {
    id: "committed",
    dmsLabelColor: "#CC911F",
    dmsLabel: "Committed",
    dmsColor: "#FFF9EF",
  },
  {
    id: "Partially Approved",
    dmsLabelColor: "#17B4A3",
    dmsLabel: "Partially Approved",
    dmsColor: "#F0FBFF",
  },
];

export const stockTypeTransferMapping: { [key: string]: string[] } = {
  Committed: ["Unsellable"],
  Available: ["Unsellable"],
  Unsellable: ["Returned"],
  Returned: ["Available", "Unsellable"],
};

export const StockTypeUpdateColumnsMetadata = {
  columns: [
    {
      headerName: "Last Updated On",
      mappedValue: "adjustmentDate",
      width: 170,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "SKU Code",
      mappedValue: "skuCode",
      width: 180,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "SKU Name",
      mappedValue: "skuDescription",
      width: 390,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Updated Batch IDs",
      mappedValue: "batchIdCount",
      width: 160,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Stock Qty",
      mappedValue: "updatedStockQuantity",
      width: 160,
      headerAlign: "left",
      align: "left",
      type: "stocks",
    },
    {
      headerName: "",
      mappedValue: "eyeIcon",
      width: 10,
      headerAlign: "left",
      align: "center",
    },
  ],
  Actions: [],
};

export const StockTypeUpdateSkuDetailsGridMetaData = {
  columns: [
    {
      headerName: "Batch ID",
      mappedValue: "batchId",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Updated Qty",
      mappedValue: "updatedQty",
      width: 200,
      headerAlign: "left",
      align: "left",
      type: "stocks",
    },
    {
      headerName: "Stock Type From",
      mappedValue: "status",
      width: 230,
      headerAlign: "left",
      align: "left",
      type: "stocks",
    },
    {
      headerName: "Stock Type To",
      mappedValue: "toStatus",
      width: 230,
      headerAlign: "left",
      align: "left",
      type: "stocks",
    },
    {
      headerName: "Stock Type Update Reason",
      mappedValue: "reason",
      width: 260,
      headerAlign: "left",
      align: "left",
    },
  ],
  Actions: [],
};

export const StockTypeUpdateSkuDetailsMetaData1: any[] = [
  {
    keys: "skuDescription",
    label: "SKU Name",
    index: 1,
  },
  {
    keys: "batchIdCount",
    label: "Batch IDs",
    index: 2,
  },
];

export const StockTypeUpdateSkuDetailsMetaData2: any[] = [
  {
    keys: "adjustmentDate",
    label: "Last Updated On",
    index: 1,
  },
];
